import React, { useState } from 'react'

// next components
import { useDispatch } from 'react-redux'

// third party components

// components
// import StudioReleaseCard from 'components/Card/StudioReleaseCard'
import ImageWithFoster from 'components/ImageWithFoster'

// images
const PrintImage = 'https://foster-marketplace-dev.s3.us-east-2.amazonaws.com/physical-print-image.webp'

import MerchOpenIcon from 'assets/icons/merch-open-icon.svg?component'

// json
import StudioApparelList from 'assets/json/hero/hero-apparel-list.json'

// styles
import styles from './index.module.scss'
// import WallArtCard from 'components/Card/WallArtCard'
import SelectPrintModal from 'components/Modal/SelectPrintModal'
// api

const ShopApparelSection = props => {
  const { title, nftDetail, nftCreator, shopApparelList, openMerchPage, type = '' } = props
  const [openSelectPrintModal, setOpenSelectPrintModal] = useState(false)
  const dispatch = useDispatch()
  const nftName = (nftDetail.name || nftDetail.json?.name) ?? 'No name found'
  const nftCoverUrl = nftDetail.original.image ?? ''
  // const originalUrl = nftDetail.original.image ?? ''
  const mintAddress = nftDetail.mintAddress

  const openPage = print => {
    let lists = shopApparelList.filter(item => item.name === print)
    let item = lists[0]
    let params = {
      nftName,
      nftCreator,
      nftCoverUrl,
      mintAddress,
      category: item.category,
      subCategory: item.sub_type,
      base: item.base,
    }
    openMerchPage(params)
  }

  const getStudioItem = item => {
    let studioList = StudioApparelList.filter(studio => studio.name === item.name)
    return studioList[0]
  }

  return (
    shopApparelList.length > 0 && (
      <section className={styles.container}>
        <div className={styles.printArea} onClick={() => setOpenSelectPrintModal(true)}>
          <div className="min-w-[92px] lg:min-w-[147px] w-[147px] h-[92px] lg:h-[147px]">
            <ImageWithFoster src={PrintImage} />
          </div>
          <div className="w-full py-[13px] lg:py-[24px] pl-[10px] lg:pl-[27px]">
            <div className={styles.title}>Physical Prints Available!</div>
            <div className="hidden lg:block">
              <div className={styles.desc}>
                Choose from matte paper,
                <br />
                canvas, glossy metal, or luster
                <br />
                photo paper.
              </div>
            </div>
            <div className="block lg:hidden">
              <div className={styles.desc}>
                Choose from matte paper, canvas,
                <br />
                glossy metal, or luster photo paper.
              </div>
            </div>
          </div>
          <div className="pt-[10px] pr-[10px] h-full flex items-start justify-start">
            <MerchOpenIcon />
          </div>
        </div>

        {/* <div className={styles.merchTitle}>Purchase Print</div>
        <div className={styles.border} />

        <div className="w-full grid grid-cols-2 gap-[20px] sm:gap-[30px] mt-[15px] lg:mt-[30px]">
          {shopApparelList.map((item: any, index) => (
            <div key={index}>
              {item.category === 'print' && (
                <WallArtCard
                  type={item.sub_type}
                  image={item.asset_url}
                  label={item.label}
                  startPrice={item.start_price}
                  onClick={() => {
                    openPage(item)
                  }}
                />
              )}
            </div>
          ))}
        </div> */}

        {openSelectPrintModal && (
          <SelectPrintModal
            open={openSelectPrintModal}
            close={() => {
              setOpenSelectPrintModal(false)
            }}
            onClick={print => openPage(print)}
          />
        )}

        {/* <div className={styles.merchTitle}>Shop Merch</div>
        <div className={styles.border} />

        <div className="w-full grid grid-cols-2 gap-[20px] sm:gap-[30px] mt-[15px] lg:mt-[30px]">
          {shopApparelList.map((item: any, index) => (
            <div key={index}>
              {item.category === 'apparel' && (
                <StudioReleaseCard
                  type="nft"
                  image={getStudioItem(item)}
                  nftImage={nftCoverUrl}
                  originalImage={originalUrl}
                  nftName={nftName}
                  userName={item.label}
                  nftCreator={nftCreator}
                  size={item.range}
                  onClick={colorNumber => {
                    dispatch({ type: 'set', apparelColor: colorNumber })
                    openPage(item)
                  }}
                />
              )}
            </div>
          ))}
        </div> */}
      </section>
    )
  )
}

export default ShopApparelSection
